import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from "../../environments/environment";
import {Token} from "../entity/token";

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {

  constructor(private http: HttpClient) {}

  getReportEmbedToken(groupId: string): Observable<Token[]> {
    return this.http.get<Token[]>(environment.authorizerServiceUrl + 'api/token?groupId=' + groupId);
  }
}
